// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const TermsAndPrivacyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
`;
